import configureStore from './index';

const initialState = {};
const store = configureStore(initialState);

export default store;